import { useEffect, useState } from 'react';

// Service
import CashRegisterService from '../../services/cashRegisterService';

//Hooks
import useUser from "../user/useUser";
import useQueryString from '../queryString/useQueryString';
import { utils } from '../../utils/utils';

const initialState = {
    items: [],
    totalResults: 0,
    totalPage: 1,
    filters: {
        cashRegisterId: '',
        reason: '',
        from: utils.getDateNow(),
        to: '',
        cashType: '',
        pageSize: 10,
        pageNumber: 1,
        isImprest: false
    }
}

const useCashRegisterMovements = () => {
    const { branch, cashRegister } = useUser();

    const { filters, setParameterSearch, clearFilters } = useQueryString({
        pageSize: 10,
        pageNumber: 1,
        isImprest: false
    });

    useEffect(() => {
        if (cashRegister?.id && !filters.cashRegisterId) {
            setParameterSearch({
                ...filters,
                cashRegisterId: cashRegister.id,
                pageNumber: 1
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cashRegister]);

    const [loading, setLoading] = useState(false);
    const [loadingPrint, setLoadingPrint] = useState(false);
    const [cashRegisterState, setCashRegisterState] = useState(initialState);

    useEffect(() => {
        const SearchCashRegisterMovements = async () => {
            setLoading(true);

            await CashRegisterService
                .SearchMovements(filters?.pageSize, filters?.pageNumber, { ...filters, isImprest: false }, branch?.id)
                .then(res =>
                    setCashRegisterState(state => ({
                        ...state,
                        items: res.values,
                        totalResults: res.totalResults,
                        totalPage: res.totalPage
                    })))
                .finally(() => setLoading(false));
        }

        if (branch && branch?.id && branch?.id !== 0)
            SearchCashRegisterMovements();
    }, [branch, filters])

    const getDepositReceipt = async (itemId) => {
        setLoadingPrint(true);
        const template = await CashRegisterService.GetDepositReceipt(itemId);
        utils.printTemplate(template);
        setLoadingPrint(false);
    }

    return {
        cashRegisterMovements: cashRegisterState.items,
        totalPage: cashRegisterState.totalPage,
        loading,
        loadingPrint,
        filters,
        clearFilters,
        setParameterSearch,
        getDepositReceipt
    }
}

export default useCashRegisterMovements;